// removed by extract-text-webpack-plugin
module.exports = {"tabActiveButton":"_1pkag","tabInactiveButton":"_1XjJd"};


//////////////////
// WEBPACK FOOTER
// ./src/styles/base.scss
// module id = 529
// module chunks = 0